// Permission Service
// Frontend-facing client for the SAME role_permissions model that already
// gates workspaces/agents/FLEX scripts server-side (PermissionService.java,
// RolePermission.TargetTypes). Use this instead of hardcoding a
// hasRole('SOME_STRING') check in a component -- the required role for a
// given action is data (a role_permissions row), not something baked into
// the frontend, so it can be reconfigured (or opened up to more roles)
// without a code change. Added 2026-09-27 per explicit direction: every
// action a user can perform in FAST Studio should check role permissions
// through the existing access-control system.

const API_BASE = '/api/permissions';

class PermissionService {
  static getAuthHeaders() {
    const token = localStorage.getItem('waide_access_token');
    return {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    };
  }

  /**
   * Can the current user access this resource/action? Mirrors
   * PermissionService.canAccessResource on the backend -- DEFAULT-ALLOW:
   * resolves to true if nothing gates this targetType+targetId yet.
   * @param {string} targetType - one of RolePermission.TargetTypes
   *   (DOMAIN, WORKSPACE, AGENT, FLEX_SCRIPT, ACTION)
   * @param {string} targetId - the specific resource, or '*' for "every
   *   resource of this targetType"
   * @returns {Promise<boolean>}
   */
  static async canAccess(targetType, targetId) {
    try {
      const params = new URLSearchParams({ targetType, targetId });
      const response = await fetch(`${API_BASE}/check?${params}`, {
        headers: this.getAuthHeaders(),
      });
      if (!response.ok) {
        // Fail closed -- if the check itself errors, don't show a gated
        // action as available.
        return false;
      }
      const data = await response.json();
      return data.allowed === true;
    } catch (e) {
      console.error('Permission check failed:', e);
      return false;
    }
  }
}

export default PermissionService;
